import { render, staticRenderFns } from "./QCPermissionEditor.vue?vue&type=template&id=2e221397&scoped=true&"
import script from "./QCPermissionEditor.vue?vue&type=script&lang=js&"
export * from "./QCPermissionEditor.vue?vue&type=script&lang=js&"
import style0 from "./QCPermissionEditor.vue?vue&type=style&index=0&id=2e221397&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e221397",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VForm,
  VIcon,
  VSelect,
  VTextField,
})
